import { Component } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import CsLineIcons from "../../cs-line-icons";

export default class OverlayedButton extends Component {
  get defaultPlacement() {
    return "bottom";
  }

  get button() {
    return (
      <span style={{ cursor: "pointer", display: "inline-flex", alignItems: "center", gap: "4px" }} onClick={this.props.onClick}>
            {this.props.caption}
            {this.props.icon ?
                <div
                    style={{
                        border: `1px solid ${this.props.iconBorderColor ?? "#007BFF"}`,
                        color: this.props.iconColor ?? "#007BFF",
                        borderRadius: "3px",
                        cursor: "pointer",
                        height: "12px",
                        width: "12px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        lineHeight: 0, // helps keep the box tight
                    }}
                    onClick={this.props.onIconClick}
                >
                    <CsLineIcons icon={this.props.icon} size={8} />
                </div>
            : null}
      </span>
    );
  }

  get overlay() {
    const placement = this.props.overlayPlacement ?? this.defaultPlacement;
    const tooltipText = this.props.tooltip ?? this.props.caption;
    if (this.props.hidden) return null;

    return (
      <OverlayTrigger
        delay={{ show: 10, hide: 0 }}
        placement={placement}
        overlay={<Tooltip id="creatable-tooltip">{tooltipText}</Tooltip>}
      >
        {this.button}
      </OverlayTrigger>
    );
  }

  render() {
    return this.overlay;
  }
}